// src/components/hero/hero.jsx
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './hero.css';

import wetlandSlide from '../../img/projects/kibumba-wetland-hero.jpg';
import greenComplexSlide from '../../img/projects/kigali-green-complex-client.jpg';
import solarSlide from '../../img/environment/solar.jpg';

const slides = [
  { image: wetlandSlide, position: 'center 48%' },
  { image: greenComplexSlide, position: 'center 38%' },
  { image: solarSlide, position: 'center' },
];

function EcoDesignHero() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5500,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    arrows: true,
    pauseOnHover: false,
  };

  return (
    <section className="eco-hero">
      <div className="eco-hero-gradient" aria-hidden="true" />
      <Slider {...settings}>
        {slides.map((slide, i) => (
          <div className="eco-hero-slide" key={i}>
            <div
              className="eco-hero-bg"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundPosition: slide.position,
              }}
              aria-hidden="true"
            />
            <div className="eco-hero-content">
              {i === 0 ? (
                <>
                  <h1 className="eco-hero-title">
                    <span className="eco-hero-brand-1">Eco</span>
                    <span className="eco-hero-brand-2">design</span> &{' '}
                    <span className="eco-hero-brand-3">Protect Ltd</span>
                  </h1>
                  <p className="eco-hero-sub">
                    Innovative environmental solutions for a sustainable future.
                  </p>
                  <div className="eco-hero-cta-row">
                    <a href="/our-services" className="eco-cta primary">Our Services</a>
                    <a href="/contact-us" className="eco-cta ghost">Contact Us</a>
                  </div>
                </>
              ) : i === 1 ? (
                <>
                  <h2 className="eco-hero-title">Environmental Consultancy</h2>
                  <p className="eco-hero-sub">Expert guidance for sustainable development.</p>
                  <div className="eco-hero-cta-row">
                    <a href="/our-services" className="eco-cta primary">Explore Services</a>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="eco-hero-title">Sustainable Solutions</h2>
                  <p className="eco-hero-sub">Building a greener future together.</p>
                  <div className="eco-hero-cta-row">
                    <a href="/contact-us" className="eco-cta primary">Get in Touch</a>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default EcoDesignHero;
